<si-content-action-bar
  class="ms-auto pe-auto"
  viewType="expanded"
  [primaryActions]="primaryActions()"
/>
